<ng-template #goalRenameTemplate>
  <td-wb-confirm>
    <td-wb-confirm-title translate="tdWb.lti.goalRename.HEADER" />
    <td-wb-confirm-body>
      <td-wb-form>
        <td-wb-input-group class="td-wb-goal-rename__form-input">
          <td-wb-input-group-field class="td-wb-goal-rename__form-input">
            <input id="goalNameEditInput"
                    class="td-wb-goal-rename__form-input"
                    type="text"
                    required
                    maxlength="40"
                    name="goalNameEditInput"
                    tdWbInput
                    [placeholder]="'tdWb.lti.goalRename.input.required' | translate"
                    [ngModel]="goalName()"
                    (ngModelChange)="goalName.set($event)">
            <td-wb-input-errors class="td-wb-vh"
                                errorKeyNamespace="tdWb.lti.goalRename.input"
                                [errorKeyDisplayBeforeSubmit]="['required']" />
          </td-wb-input-group-field>
        </td-wb-input-group>
      </td-wb-form>
    </td-wb-confirm-body>
    <td-wb-confirm-buttons>
      <td-wb-confirm-button id="td-wb-goal-rename-button-cancel"
                            value="CANCEL">
        <span translate="tdWb.lti.goalRename.CANCEL"></span>
      </td-wb-confirm-button>
      <td-wb-confirm-button id="td-wb-goal-rename-button-confirm"
                            value="SAVE"
                            buttonType="primary">
        <span translate="tdWb.lti.goalRename.SAVE"></span>
      </td-wb-confirm-button>
    </td-wb-confirm-buttons>
  </td-wb-confirm>
</ng-template>
